import { memo } from 'react';
import { ReducedMarker } from './styled-components';

export default memo(ReducedMarker);
